"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy2"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdApollo = require("cccisd-apollo");
var _admin = require("../../../selectors/admin.js");
var _getImportantRespondentFields = _interopRequireDefault(require("../../../helpers/getImportantRespondentFields.js"));
var _respondentsByDeployment = _interopRequireDefault(require("./respondentsByDeployment.graphql"));
var _respondentsByGroup = _interopRequireDefault(require("./respondentsByGroup.graphql"));
var _respondentsFromResponses = _interopRequireDefault(require("./respondentsFromResponses.graphql"));
var _respondentIdsFromPawnIds = _interopRequireDefault(require("./respondentIdsFromPawnIds.graphql"));
var _UrlInfo = require("../UrlInfo");
var _RespondentForm = require("../RespondentForm");
var _form = _interopRequireDefault(require("../RespondentForm/form.js"));
var _LoggedPawnMessages = _interopRequireDefault(require("./renders/LoggedPawnMessages"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var RespondentTable = /*#__PURE__*/function (_React$Component) {
  function RespondentTable() {
    var _this;
    _classCallCheck(this, RespondentTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RespondentTable, [].concat(args));
    _defineProperty(_this, "state", {
      isLoading: true,
      pawnIdPath: '',
      statusPath: '',
      userPath: '',
      query: '',
      variables: {}
    });
    _defineProperty(_this, "componentDidUpdate", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(prevProps) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(prevProps.cycle.deploymentId !== _this.props.cycle.deploymentId)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return _this.setState({
                isLoading: true
              });
            case 1:
              _this.setCycleInfo();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "getColumns", function () {
      var _this$state = _this.state,
        pawnIdPath = _this$state.pawnIdPath,
        showLink = _this$state.showLink,
        statusPath = _this$state.statusPath,
        userPath = _this$state.userPath;
      var _this$props = _this.props,
        cycle = _this$props.cycle,
        project = _this$props.project,
        omitIdentifiableColumns = _this$props.omitIdentifiableColumns;
      var deploymentId = cycle.deploymentId,
        roleHandle = cycle.roleHandle;
      var individualPasscode = cycle.settings.individualPasscode;
      var appdefRoles = AppDefs.pawn.roles || [];
      var roleDef = appdefRoles.find(function (item) {
        return item.handle === cycle.roleHandle;
      }) || {};
      if (omitIdentifiableColumns) {
        var _importantFields = [];
        if (roleHandle === 'respondent') {
          _importantFields = (0, _getImportantRespondentFields["default"])({
            importantFields: _importantFields,
            project: project
          });
        }
        var _newImportantFields = _importantFields.filter(function (f) {
          return !f.identifiable;
        })
        // .filter(iF => !fields.some(f => f.importantPath === iF.path))
        .map(function (f) {
          return {
            name: "".concat(userPath, "important.").concat(f.path),
            label: f.label,
            sort: true,
            filter: true
          };
        });
        return [{
          name: "".concat(pawnIdPath, "pawnId"),
          label: 'System ID',
          sort: true,
          filter: true
        }].concat(_toConsumableArray(_newImportantFields), [{
          name: "".concat(statusPath, "startedAt"),
          label: 'Started On',
          sort: true,
          filter: true
        }, {
          name: "".concat(statusPath, "completedAt"),
          label: 'Completed',
          sort: true,
          filter: true
        }, {
          name: "".concat(userPath, "messageCount"),
          label: 'Messages Sent',
          sort: true,
          filter: true
        }]);
      }
      var fields = [{
        name: "".concat(userPath, "user.username"),
        label: 'Username',
        importantPath: 'user.username',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "user.firstName"),
        label: 'First Name',
        importantPath: 'user.firstName',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "user.lastName"),
        label: 'Last Name',
        importantPath: 'user.lastName',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "user.email"),
        label: 'E-mail',
        importantPath: 'user.email',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "user.phone"),
        label: 'Phone',
        importantPath: 'user.phone',
        sort: true,
        filter: true
      }];
      if (individualPasscode) {
        fields.splice(1, 0, {
          name: 'passcode',
          label: 'Passcode',
          importantPath: 'passcode',
          sort: true,
          filter: true
        });
      }
      var importantFields = (0, _get2["default"])(roleDef, 'importantFields') || [];
      if (roleHandle === 'respondent') {
        importantFields = (0, _getImportantRespondentFields["default"])({
          importantFields: importantFields,
          project: project
        });
      }
      var newImportantFields = importantFields.filter(function (iF) {
        return !fields.some(function (f) {
          return f.importantPath === iF.path;
        });
      });
      newImportantFields.forEach(function (f) {
        fields.push({
          name: "".concat(userPath, "important.").concat(f.path),
          label: f.label,
          sort: true,
          filter: true
        });
      });
      fields.push({
        name: "".concat(statusPath, "startedAt"),
        label: 'Started On',
        sort: true,
        filter: true
      }, {
        name: "".concat(statusPath, "completedAt"),
        label: 'Completed',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "messageCount"),
        label: 'Messages Sent',
        sort: true,
        filter: true,
        render: function render(_ref2) {
          var value = _ref2.value,
            row = _ref2.row;
          return /*#__PURE__*/_react["default"].createElement(_LoggedPawnMessages["default"], {
            deploymentId: deploymentId,
            pawnIdPath: pawnIdPath,
            row: row,
            userPath: userPath
          });
        }
      }, {
        name: 'actions',
        label: 'Actions',
        render: function render(_ref3) {
          var value = _ref3.value,
            row = _ref3.row;
          return _this.renderActionButtons(row);
        },
        hideInCsv: true
      });
      if (showLink) {
        fields.push({
          name: 'pawn.pawn.respondentHash',
          label: 'Personal Link',
          render: function render(_ref4) {
            var row = _ref4.row;
            return _this.getLinkFromRow(row);
          },
          hideInTable: true
        });
      }
      return fields;
    });
    _defineProperty(_this, "onSubmit", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row, values) {
        var pawnId, respondentId, pawnResponse, respondentResponse;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              pawnId = row.pawnId, respondentId = row.respondentId;
              _context2.n = 1;
              return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
                pawn: pawnId
              }), (0, _RespondentForm.getParams)(values));
            case 1:
              pawnResponse = _context2.v;
              if (!pawnResponse.data.errors) {
                _context2.n = 2;
                break;
              }
              (0, _cccisdNotification["default"])({
                duration: 0,
                message: 'Error',
                type: 'danger',
                data: pawnResponse.data.errors
              });
              return _context2.a(2, Promise.reject(_objectSpread({}, pawnResponse.data.errors)));
            case 2:
              _context2.n = 3;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeploymentRespondent.update', {
                respondentId: respondentId
              }), (0, _RespondentForm.getParams)(values));
            case 3:
              respondentResponse = _context2.v;
              if (!respondentResponse.data.errors) {
                _context2.n = 4;
                break;
              }
              (0, _cccisdNotification["default"])({
                duration: 0,
                message: 'Error',
                type: 'danger',
                data: respondentResponse.data.errors
              });
              return _context2.a(2, Promise.reject(_objectSpread({}, respondentResponse.data.errors)));
            case 4:
              _context2.n = 5;
              return _this.table.loadData();
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "renderActionButtons", function (row) {
      var cycle = _this.props.cycle;
      var _this$state2 = _this.state,
        canRemove = _this$state2.canRemove,
        showLink = _this$state2.showLink;

      // canRemove is not all there is to it. need to look for quest.modify_data permission as well
      // if canRemove and row has no data (startedAt is null, allow)
      // if canRemove and row does have data, need to ALSO have quest.modify_data permission
      var canDelete = canRemove && (row['pawn.assignmentProgress.startedAt'] === null || window.cccisd.fortress.hasAccess('quest.modify_data', row['deployment.assignment.group.group.groupId']));
      var btnCount = [showLink, ['anon', 'known'].includes(cycle.type), canRemove].reduce(function (count, bool) {
        return bool ? count + 1 : count;
      }, 0);
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          minWidth: btnCount * 31
        }
      }, showLink && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Copy Link",
        type: "default"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn', 'btn-xs', 'btn-info', _style["default"].btn),
        onClick: function onClick() {
          return (0, _UrlInfo.setClipboardText)(_this.getLinkFromRow(row));
        }
      }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null))), ['anon', 'known'].includes(cycle.type) && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Edit",
          type: "default"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: (0, _classnames["default"])('btn', 'btn-xs', 'btn-success', _style["default"].btn)
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
        title: "Edit Respondent Info",
        render: function render(_ref6) {
          var closeModal = _ref6.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_form["default"], {
            onSubmit: (/*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(values) {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      values.pawnHash = row["".concat(_this.state.userPath, "pawn.pawnHash")];
                      _context3.n = 1;
                      return _this.onSubmit(row, values);
                    case 1:
                      closeModal();
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              }));
              return function (_x4) {
                return _ref7.apply(this, arguments);
              };
            }()),
            forCycle: cycle,
            initialValues: _objectSpread({
              roleHandle: cycle.roleHandle
            }, (0, _RespondentForm.getValues)(row)),
            isEditing: true
          });
        }
      }), canDelete && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Remove",
        type: "default"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn', 'btn-xs', 'btn-danger', _style["default"].btn),
        onClick: _this.removeRespondentFunc([row.respondentId])
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))));
    });
    _defineProperty(_this, "getLinkFromRow", function (row) {
      return Boilerplate.url(_this.state.baseUri + row["".concat(_this.state.userPath, "pawn.respondentHash")]);
    });
    _defineProperty(_this, "getRowActions", function () {
      var actions = [];

      // "Send Message" button is smart enough to know how many rows are selected,
      // so we should show row-action checkboxes if the "Send Message" button is visible,
      // regardless of whether there are any row-actions or not
      //
      // TO-DO: Make "Send Message" into a row-action in addition to the button
      // so that this code is not confusing.
      actions.push({
        name: 'doNothing',
        title: '-- unselect all --',
        action: function action() {}
      });
      if (_this.state.canRemove) {
        actions.push({
          name: 'removeRespondents',
          title: 'Remove Respondent(s)',
          action: function () {
            var _action = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref8) {
              var selectedRows;
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    selectedRows = _ref8.selectedRows;
                    _context5.n = 1;
                    return _cccisdApollo.client.query({
                      query: _respondentIdsFromPawnIds["default"],
                      variables: {
                        pawnIds: selectedRows,
                        deploymentId: _this.props.cycle.deploymentId
                      }
                    }).then(/*#__PURE__*/function () {
                      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
                        var _res$data;
                        return _regenerator().w(function (_context4) {
                          while (1) switch (_context4.n) {
                            case 0:
                              if (!((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.flows.deployment.respondentList)) {
                                _context4.n = 1;
                                break;
                              }
                              _context4.n = 1;
                              return _this.removeRespondentFunc(res.data.flows.deployment.respondentList.map(function (r) {
                                return r.respondentId;
                              }))();
                            case 1:
                              return _context4.a(2);
                          }
                        }, _callee4);
                      }));
                      return function (_x6) {
                        return _ref9.apply(this, arguments);
                      };
                    }());
                  case 1:
                    return _context5.a(2);
                }
              }, _callee5);
            }));
            function action(_x5) {
              return _action.apply(this, arguments);
            }
            return action;
          }()
        });
      }
      return actions;
    });
    _defineProperty(_this, "setCycleInfo", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var _this$props2, cycle, project, _t;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _this$props2 = _this.props, cycle = _this$props2.cycle, project = _this$props2.project;
            _t = cycle.type;
            _context6.n = _t === 'anon' ? 1 : _t === 'known' ? 3 : _t === 'group' ? 5 : 9;
            break;
          case 1:
            _context6.n = 2;
            return _this.setState({
              userPath: 'pawn.',
              pawnIdPath: '',
              statusPath: '',
              query: _respondentsFromResponses["default"],
              variables: {
                deploymentId: cycle.deploymentId,
                projectId: project.groupId
              }
            });
          case 2:
            return _context6.a(3, 9);
          case 3:
            _context6.n = 4;
            return _this.setState({
              userPath: 'pawn.',
              statusPath: 'pawn.assignmentProgress.',
              pawnIdPath: '',
              query: _respondentsByDeployment["default"],
              variables: {
                deploymentId: cycle.deploymentId,
                projectId: project.groupId
              }
            });
          case 4:
            return _context6.a(3, 9);
          case 5:
            if (!cycle.settings.closedRoster) {
              _context6.n = 7;
              break;
            }
            _context6.n = 6;
            return _this.setState({
              userPath: 'pawn.',
              statusPath: 'pawn.assignmentProgress.',
              pawnIdPath: '',
              query: _respondentsByDeployment["default"],
              variables: {
                deploymentId: cycle.deploymentId
              }
            });
          case 6:
            _context6.n = 8;
            break;
          case 7:
            _context6.n = 8;
            return _this.setState({
              pawnIdPath: 'pawn.',
              statusPath: 'assignmentProgress.',
              userPath: '',
              query: _respondentsByGroup["default"],
              variables: {
                deploymentId: cycle.deploymentId,
                roleHandle: cycle.roleHandle
              }
            });
          case 8:
            return _context6.a(3, 9);
          case 9:
            _context6.n = 10;
            return _this.setState({
              isLoading: false,
              showLink: !cycle.settings.requireLogin && !cycle.settings.requirePass,
              baseUri: cycle.settings.useEndpoint ? "survey/".concat(cycle.endpoint, "/") : "d/".concat(cycle.hash, "/"),
              canRemove: cycle.type === 'known' || cycle.type === 'group' && cycle.settings.closedRoster
            });
          case 10:
            return _context6.a(2);
        }
      }, _callee6);
    })));
    _defineProperty(_this, "removeRespondentFunc", function (ids) {
      return function () {
        var cycle = _this.props.cycle;
        (0, _cccisdConfirm["default"])({
          message: 'Confirm Removal',
          description: 'Are you sure you want to remove this respondent?',
          confirmLabel: 'Yes',
          abortLabel: 'Cancel'
        }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
          var response, message;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                _context7.n = 1;
                return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeploymentRespondent.destroy', {
                  deploymentId: cycle.deploymentId
                }), {
                  deploymentRespondentIds: ids
                });
              case 1:
                response = _context7.v;
                if (!response.data.errors) {
                  _context7.n = 2;
                  break;
                }
                message = Object.keys(response.data.errors).join(' ');
                return _context7.a(2, Promise.reject({
                  title: message
                }));
              case 2:
                _context7.n = 3;
                return _this.table.loadData();
              case 3:
                return _context7.a(2);
            }
          }, _callee7);
        })));
      };
    });
    return _this;
  }
  _inherits(RespondentTable, _React$Component);
  return _createClass(RespondentTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setCycleInfo();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state3 = this.state,
        isLoading = _this$state3.isLoading,
        pawnIdPath = _this$state3.pawnIdPath,
        query = _this$state3.query,
        variables = _this$state3.variables;
      if (isLoading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
        isStickyHeader: true,
        showDoubleScrollbar: true,
        columns: this.getColumns(),
        query: query,
        rowKey: "".concat(pawnIdPath, "pawnId"),
        graphqlVariables: variables,
        rowActions: this.getRowActions(),
        ref: function ref(element) {
          _this2.table = element;
        },
        csvSaveHeader: true
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(RespondentTable, "propTypes", {
  cycle: _propTypes["default"].object,
  omitIdentifiableColumns: _propTypes["default"].bool,
  // from redux
  project: _propTypes["default"].object
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    project: (0, _admin.getCurrentProject)(state.assignment.admin, props)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, null, null, {
  forwardRef: true
})(RespondentTable);